var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.999,
    height: 35.001,
    viewBox: "0 0 34.999 35.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help",
    transform: "translate(-0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30472",
    "data-name": "Path 30472",
    d: "M17.508,0a17.5,17.5,0,1,0,17.5,17.491A17.5,17.5,0,0,0,17.508,0Zm1.247,27.229a2.061,2.061,0,0,1-1.411.543,2.131,2.131,0,0,1-1.445-.536,1.879,1.879,0,0,1-.618-1.5,1.932,1.932,0,0,1,.6-1.438,2.016,2.016,0,0,1,1.465-.583,1.993,1.993,0,0,1,2.023,2.021A1.9,1.9,0,0,1,18.755,27.229Zm5.068-12.565a6.187,6.187,0,0,1-1.113,1.5q-.643.631-2.314,2.123a9.575,9.575,0,0,0-.739.739,3.012,3.012,0,0,0-.414.584,2.812,2.812,0,0,0-.21.53q-.074.264-.225.93a1.509,1.509,0,0,1-1.614,1.411,1.653,1.653,0,0,1-1.188-.461,1.813,1.813,0,0,1-.481-1.37,5.05,5.05,0,0,1,.353-1.974,4.99,4.99,0,0,1,.936-1.466,21.454,21.454,0,0,1,1.575-1.5q.869-.76,1.255-1.146a3.88,3.88,0,0,0,.651-.862,2.075,2.075,0,0,0,.264-1.031,2.394,2.394,0,0,0-.807-1.831,2.948,2.948,0,0,0-2.083-.746,2.882,2.882,0,0,0-2.2.753,6.009,6.009,0,0,0-1.194,2.218q-.462,1.534-1.75,1.534a1.723,1.723,0,0,1-1.283-.536,1.639,1.639,0,0,1-.522-1.16,4.909,4.909,0,0,1,.827-2.612A6.369,6.369,0,0,1,13.965,8.1a7.6,7.6,0,0,1,3.7-.869,7.9,7.9,0,0,1,3.473.727A5.63,5.63,0,0,1,23.47,9.93a4.845,4.845,0,0,1,.821,2.714A4.179,4.179,0,0,1,23.824,14.664Z",
    transform: "translate(0)",
    fill: "#1b1c1d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.ba8a5e2eddb6cd95ddb7a5a0158aa1fd.svg";
export { ForwardRef as ReactComponent };